import { useState, useEffect, useRef } from "react";
import CryptoJS from "crypto-js";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { register } from "../actions/userAction";
import { loaduser } from "../actions/userAction";
import OverwolfLogo from "../images/Overwolf_logo.png";
import { errorToast, infoToast } from "../constants/ToastNotifications";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CircularProgress } from '@mui/material';
import RegisterImg1 from "../images/Pay options.png";
import RegisterImg2 from "../images/Mobile app.png";
import RegisterImg3 from "../images/Games.png";
import checkmark from "../images/Check_ring_winner.svg";
import Select from 'react-select';
import Checkmark from './Checkmark';
import styles from "./Register.module.css";
import countrylist from '../country-states.json';
import "../Pages/Profile.css";
export const Register = () => {
 
  const { loading, isAuthenticated, user, error } = useSelector(
    (state) => state.user
  );
  
  const [registerLoading,setRegisterLoading] = useState(false)
  const dispatch = useDispatch();
  const selectInputRef = useRef();
  // const alert = useAlert();
  const navigate = useNavigate();
  const [validatingUsername, setValidatingUsername] = useState(false);
  const [usernameIsValid, setUsernameIsValid] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [inputValue, setInputValue] = useState({
    username: "",
    email: "",
    dateOfBirth: "",
    password: "",
    avatar: "",
    referralCode: "",
    overwolfData: null
  });

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [agreedToAge, setAgreedToAge] = useState(false);
  const [stateList, setStateList] = useState([]);

  //Username validation
  useEffect(() => {
    if(!inputValue.username?.trim()) return;
    setValidatingUsername(true);

    const controller = new AbortController();
    const signal = controller.signal;

    const timer = setTimeout(() => {
      handlecheckusername(signal)
        .then((isValid) => {
          if(isValid === null) return;
          setValidatingUsername(false);
          setUsernameIsValid(isValid);
      });
    }, 1000);

    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [inputValue.username]);

  //Check if username is available
  const handlecheckusername = async (abortSignal) => {
    let data;
    try{
      const response = await axios.post(`/api/auth/checkUsername`, {username:inputValue.username}, {signal:abortSignal});
      data = response.data;
    } catch (error) {
      if (error.name === 'AbortError') return null;
    }
    if(!data) return null;
    if(data.success) return true;
    if(!data.success && data?.message){
      errorToast(data?.message);
      setRegisterLoading(false)
    }
    return false;
  };

  //Username validation info that appears below input field
  const usernameValidationInfo = () => {
    if(inputValue.username?.trim().length > 0){
      if(validatingUsername){
        return <p className={styles['register_username_info']}><CircularProgress size={8} style={{marginRight: '5px'}}/>Validating Username...</p>;
      } else if(usernameIsValid){
        return <p className={`${styles['register_username_info']} ${styles.success}`}>Username is available</p>;
      } else {
        return <p className={`${styles['register_username_info']} ${styles.fail}`}>Username is taken</p>;
      }
    }
  }

  const validateReferralCode = async () => {
    if(!inputValue.referralCode.trim()) return true;
    const res = await axios.post(`/api/auth/checkReferralCode`, {referralCode: inputValue.referralCode});
    if(!res.data?.success) return false;
    return res.data?.isValid;
  };

  //Check if user is above 18 years old
  const validateAge = (dateString) => {
    const today = new Date();
    const selectedDate = new Date(dateString);
    let age = today.getFullYear() - selectedDate.getFullYear();
    const monthDiff = today.getMonth() - selectedDate.getMonth();
  
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < selectedDate.getDate())) {
      age--;
    }
  
    return age >= 18;
  };

  // const handleimage = (e) => {
  //   console.log(e.target.files);
  //   setSelectedImage(e.target.files);

  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     if (reader.readyState === 2) {
  //       // setavatarPreview(reader.result);
  //       setAvatarpreview(reader.result);
  //     }
  //   };

  //   reader.readAsDataURL(e.target.files[0]);
  // };

  //Handles the country dropdown
  const handleCountry = (value) => {
    setSelectedState(null);
    setSelectedCountry(value.value);
    setStateList(() => {
      return countrylist.countries.find(item => item.country === value.value).states
    })
  }

  //Handles the state dropdown
  const handleState = (value) => {
    if(value?.value === "Arizona"  ||
      value?.value === "Arkansas" ||
      value?.value === "Connecticut" ||
      value?.value === "Delaware" ||
      value?.value === "Florida" ||
      value?.value === "Indiana" ||
      value?.value === "Louisiana" ||
      value?.value === "Maryland" ||
      value?.value === "Minnesota" ||
      value?.value === "Montana" ||
      value?.value === "South Carolina" ||
      value?.value === "South Dakota" ||
      value?.value === "Tennessee" ||
      value?.value === "Wyoming"
    ){
      setSelectedState(null);
      errorToast("We regret to inform you that our services are not available in your state.")
    } else {
      setSelectedState(value);
    }
  }

  //Handles the input fields
  const handleUsername = (e) => {
    setInputValue(prev => ({ ...prev, username: e.target.value }));
  };
  const handleEmail = (e) => {
    setInputValue(prev => ({ ...prev, email: e.target.value }));
  };
  const handlePassword = (e) => {
    setInputValue(prev => ({ ...prev, password: e.target.value }));
  };
  const handleReferralCode = (e) => {
    setInputValue(prev => ({ ...prev, referralCode: e.target.value }));
  };

  //Verifies that the user is above 18 years old
  function validateDateOfBirth(){
    const Date=inputValue.dateOfBirth.$D;
    const month=inputValue.dateOfBirth.$M;
    const year=inputValue.dateOfBirth.$y;
    const exactMonth=month+1;
    const formattedDate=`${year}-${exactMonth}-${Date}`;

    if(!Date || !exactMonth || !year){
      errorToast("Please select your birthday");
      return false;
    }
    const isAbove18 = validateAge(inputValue.dateOfBirth);
    if(formattedDate && !isAbove18){
      errorToast("You must be at least 18 years old to participate on Gamewagrs.com");
      console.log("less than 18 years.");
      return false;
    }
    return true;
  }
  //Validates that the user has selected a country
  function validateCountry(){
    if(!selectedCountry || selectedCountry == null){
      errorToast("Please select your country");
      return false;
    }
    return true;
  }
  //Validates that the user has selected a state
  function validateState(){
    if(!selectedState || selectedState == null){
      errorToast("Please select your state");
      return false;
    }
    return true;
  }
  //Validates that the username is valid
  function validateUsername(){
    const isUsernameValid = (
      !!inputValue.username &&
      inputValue.username.length > 0 &&
      !validatingUsername &&
      usernameIsValid
    );
    if(!isUsernameValid){
      errorToast("Please enter a valid username");
      return false;
    }
    return true;
  }
  //Validates that the email is correctly formatted
  function verifyEmailSyntax(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email)
  }
  //Validates that the email is valid
  function validateEmail(){
    const isEmailValid = (
      !!inputValue.email &&
      inputValue.email.length > 0 &&
      verifyEmailSyntax(inputValue.email)
    );
    if(!isEmailValid){
      errorToast("Please enter a valid email address");
      return false;
    }
    return true;
  }
  //Validates that the password is valid
  function validatePassword(){
    let passwordValid = false;
    if(!inputValue.password){
      errorToast("Please enter a password");
    } else if(inputValue.password.trim().length < 6){
      errorToast("Password must be at least 6 characters long");
    } else if(inputValue.password !== confirmPassword){
      errorToast("Passwords do not match");
    } else {
      passwordValid = true;
    }

    if(!passwordValid){
      return false;
    }
    return true;
  }
  //Validates that the user has agreed to the terms and conditions and the age requirement
  function validateAgreements() {
    if (!agreedToTerms) {
      errorToast("You must agree to the terms and conditions");
      return false;
    }
    if (!agreedToAge) {
      errorToast("You must verify your age");
      return false;
    }
    return true;
  }

  //Validates all registration data and makes sure it's ready for submission
  function validateRegistrationData() {
    return (
      validateUsername() &&
      validateEmail() &&
      validateDateOfBirth() &&
      validateCountry() &&
      validateState() &&
      validateReferralCode() &&
      validateAgreements() &&
      (!inputValue.overwolfData ? validatePassword() : true)
    );
  }

  //Submit data and attempt registration
  const handleSubmit = async (e) => {
    setRegisterLoading(true);
    e.preventDefault();
    if(!validateRegistrationData()) { setRegisterLoading(false); return;}

    try {
      await dispatch(
        register(
        {
          username: inputValue.username,
          email: inputValue.email,
          password: inputValue.password,
          avatar: null,
          dateOfBirth: inputValue.dateOfBirth,
          country: selectedCountry,
          state: selectedState.value,
          overwolfCode: inputValue.overwolfData?.code,
          referralCode: inputValue.referralCode
        },
        navigate,
        infoToast
        )
      );
    } catch (error) {
      console.error('Registration error:', error);
    } finally {
      setRegisterLoading(false);
    }
  };

  useEffect(() => {
    if (error) {
      errorToast(error.message);
    }
  }, [error, isAuthenticated, navigate]);
  
  if (localStorage.getItem("nftuser")) {
    navigate("/ChallengeSomeone");
  }

  useEffect(() => {
    const overwolfDataCheck = (event) => {
      if (event.origin !== process.env.REACT_APP_BASE_URL || event.data?.type !== "overwolfUserData") return;
      setInputValue(prev => ({
        ...prev,
        email: event.data.overwolfData.email ?? "",
        username: event.data.overwolfData.nickname ?? "",
        overwolfData: event.data.overwolfData
      }));
    };

    window.addEventListener("message", overwolfDataCheck);

    return () => {
      window.removeEventListener("message", overwolfDataCheck);
    };
  },[]);

  //Redirect user to Overwolf login page and sets the intent for what to do with the overwolf data
  const handleOverwolf = () => {
    const overwolfAuthBaseUrl = 'https://id.overwolf.com/oidc/auth';

    function generateCodeVerifier() {
      const randomArray = new Uint8Array(32);
      window.crypto.getRandomValues(randomArray);
      return btoa(String.fromCharCode(...randomArray))
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
    }
    function generateCodeChallenge(codeVerifier) {
      const hash = CryptoJS.SHA256(codeVerifier);
      const base64String = hash.toString(CryptoJS.enc.Base64);
      return base64String
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
    }

    const codeVerifier = generateCodeVerifier();
    localStorage.setItem("overwolfVerifier", codeVerifier);
    const codeChallenge = generateCodeChallenge(codeVerifier);

    const authParams =(
      "?client_id=" + process.env.REACT_APP_OVERWOLF_CLIENT_ID +
      "&redirect_uri=" + process.env.REACT_APP_OVERWOLF_REDIRECT_URI +
      "&scope=openid+profile+email" +
      "&code_challenge=" + codeChallenge +
      "&code_challenge_method=S256" +
      "&response_type=code"
    );

    const overwolfFullAuthUrl = overwolfAuthBaseUrl + authParams;

    const popupWindow = window.open(
      overwolfFullAuthUrl,
      "_blank"
    );
    if (localStorage.getItem("nftuser")) {
      dispatch(loaduser());
    }
  };

  return (
    <div className={styles['register-main-body']}>
      <div className={styles['register-panels-container']}>
        <div className={styles['register-left-panel']}>
          <div className={styles['register-left-panel-inner']}>
            <img src={RegisterImg1} alt="RegisterImg1" className={styles['register-left-panel-image']} />
            <div style={{ display: "flex" }}>
              <div style={{ width: "100%" }} />
              <img src={RegisterImg2} alt="RegisterImg2" className={styles['register-left-panel-image']} />
            </div>
            <img src={RegisterImg3} alt="RegisterImg3" className={styles['register-left-panel-image']} />
          </div>
        </div>
        <div className={styles['register-right-panel']}>
          <div className={styles['register-form-container']}>
            <h3 style={{ color: "white", marginBottom: 0, fontWeight: "600" }}>Create an Account  👋</h3>
            <p style={{ fontSize: "18px", color: "#8692A6" }}>Kindly fill in your details to create an account</p>

            {/* Overwolf Button */}
            <div>
              <label>*Preferred Method</label>
              <button
                className={styles['overwolf-button']}
                onClick={handleOverwolf}
                style={{ position: "relative" }}
              >
                <img src={OverwolfLogo} alt="Overwolf Logo" style={{ width: "50px" }} />
                <span style={{ position: "absolute", left: 0, right: 0, textAlign: "center" }}>Register with Overwolf</span>
                {inputValue.overwolfData && (
                  <div
                    style={{
                      position: "absolute",
                      width: "35px",
                      height: "35px",
                      right: "15px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "50%",
                      border: "2px solid #00ff00",
                    }}
                  >
                    <Checkmark size={18} color="#00ff00" width={3} />
                  </div>
                )}
              </button>
              {inputValue.overwolfData && (
                <label style={{ width: "100%", textAlign: "center", fontSize: "16px", fontWeight: "500", marginBottom: "20px" }}>
                  Overwolf Account Connected!
                </label>
              )}
            </div>
            {!inputValue.overwolfData && (
              <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", margin: "30px 0" }}>
                <div style={{ backgroundColor: "#F5F5F5", left: 0, width: "100%", height: "1px" }} />
                <span style={{ margin: "0 20px" }}>Or</span>
                <div style={{ backgroundColor: "#F5F5F5", left: 0, width: "100%", height: "1px" }} />
              </div>
            )}
            
            {/* Username Field */}
            <div style={{ marginBottom: "20px" }}>
              <label htmlFor="username" className={styles['register-form-label']}>
                Username*
              </label>
              <input
                type="text"
                id="username"
                name="username"
                className={styles['register-form-field']}
                style={{ marginBottom: "5px" }}
                value={inputValue.username}
                onChange={handleUsername}
                maxLength={48}
                placeholder="Enter username"
              />
              {usernameValidationInfo()}
            </div>

            {/* Email Field */}
            <div>
              <label htmlFor="email" className={styles['register-form-label']}>
                Email address*
              </label>
              <input
                type="text"
                id="email"
                name="email"
                className={styles['register-form-field']}
                value={inputValue.email}
                onChange={handleEmail}
                autoComplete="off"
                placeholder="Enter email address"
              />
            </div>

            {/* Date of Birth Field */}
            <div style={{ marginBottom: "20px" }}>
              <label htmlFor="dateOfBirth" className={styles['register-form-label']}>
                Date of Birth*
              </label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  id="dateOfBirth"
                  className={styles['register-form-field']}
                  value={inputValue.dateOfBirth}
                  onChange={(newValue) => setInputValue({ ...inputValue, dateOfBirth: newValue })}
                  disableFuture
                  openTo="year"
                  views={["year", "month", "day"]}
                  sx={{
                    '& .MuiInputBase-input': {
                      color: inputValue.dateOfBirth ? 'white' : '#696F79',
                    },
                    '& .MuiSvgIcon-root': {
                      color: '#696F79',
                    },
                    '& .MuiOutlinedInput-root': {
                      height: '50px',
                      backgroundColor: '#282A2F',
                      borderRadius: '5px',
                      '& .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid #8692A6',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid #8692A6',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid #8692A6',
                      },
                      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid #8692A6 !important',
                      },
                      '&.Mui-error:hover .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid #8692A6 !important',
                      },
                      '&.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid #8692A6 !important',
                      },
                    },
                    '& .MuiOutlinedInput-input': {
                      paddingLeft: '20px',
                    },
                  }}
                />
              </LocalizationProvider>
            </div>

            {/* Country Field */}
            <div style={{ marginBottom: "20px" }}>
              <label htmlFor="country" className={styles['register-form-label']}>
                Country*
              </label>
              <Select
                ref={selectInputRef}
                options={countrylist.countries.map(country => ({ value: country.country, label: country.country }))}
                onChange={handleCountry}
                placeholder="Select your country"
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: "#282A2F",
                    borderColor: "#696F79",
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isFocused ? "#007bff" : "#282A2F",
                    color: state.isFocused ? "white" : "#ffffff",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#007bff",
                    },
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: "white",
                  }),
                }}
              />
            </div>

            {/* State Field */}
            <div style={{ marginBottom: "20px" }}>
              <label htmlFor="state" className={styles['register-form-label']}>
                State*
              </label>
              <Select
                ref={selectInputRef}
                options={stateList.map(state => ({ value: state, label: state }))}
                onChange={handleState}
                value={selectedState}
                isDisabled={!selectedCountry || stateList.length === 0}
                placeholder="Select your state"
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: selectedCountry ? "#282A2F" : "#202225",
                    borderColor: selectedCountry ? "#696F79" : "#282A2F",
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isFocused ? "#007bff" : "#282A2F",
                    color: state.isFocused ? "white" : "#ffffff",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#007bff",
                    },
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: "white",
                  }),
                }}
              />
            </div>

            {/* Password Field */}
            {!inputValue.overwolfData &&
              <div style={{ marginBottom: "20px" }}>
                <label htmlFor="password" className={styles['register-form-label']}>
                  Password*
                </label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  className={styles['register-form-field']}
                  style={{ marginBottom: "5px" }}
                  value={inputValue.password}
                  onChange={handlePassword}
                  maxLength={48}
                  placeholder="Enter password"
                  autoComplete="new-password"
                />
              </div>
            }

            {/* Password Confirmation Field */}
            {!inputValue.overwolfData &&
              <div style={{ marginBottom: "20px" }}>
                <label htmlFor="confirmPassword" className={styles['register-form-label']}>
                  Confirm Password*
                </label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  className={styles['register-form-field']}
                  style={{ marginBottom: "5px" }}
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  maxLength={48}
                  placeholder="Re-enter password"
                  autoComplete="new-password"
                />
                {confirmPassword !== undefined && confirmPassword.length > 0 && confirmPassword !== inputValue.password && (
                  <p className={`${styles['register_username_info']} ${styles.fail}`}>Passwords do not match</p>
                )}
              </div>
            }

            {/* Referral Code Field */}
            <div style={{ marginBottom: "20px" }}>
              <label htmlFor="referralCode" className={styles['register-form-label']}>
                Referral Code (optional)
              </label>
              <input
                type="text"
                id="referralCode"
                name="referralCode"
                className={styles['register-form-field']}
                style={{ marginBottom: "5px" }}
                value={inputValue.referralCode}
                onChange={handleReferralCode}
                maxLength={8}
                placeholder="Enter referral code"
              />
            </div>

            {/* Legal Toggles */}
            <div>
              <div
                className={`${styles['register-legal-toggle']} ${agreedToTerms ? styles.checked : ''}`}
                onClick={() => setAgreedToTerms(!agreedToTerms)}
              >
                <div><Checkmark size={18} color="#ffffff" width={3} opacity={agreedToTerms ? 1 : 0} /></div>
                <label>I agree to the terms & conditions</label>
              </div>
              <div
                className={`${styles['register-legal-toggle']} ${agreedToAge ? styles.checked : ''}`}
                onClick={() => setAgreedToAge(!agreedToAge)}
                style={{ marginBottom: "40px" }}
              >
                <div><Checkmark size={18} color="#ffffff" width={3} opacity={agreedToAge ? 1 : 0} /></div>
                <label>I am at least 18 years of age</label>
              </div>
            </div>

            {/* Submit Button */}
            <div>
              <button
                className={styles['register-form-button']}
                onClick={handleSubmit}
                disabled={registerLoading}
              >
                {registerLoading ? <CircularProgress size={24} /> : "Register"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
